import { createUserWithEmailAndPassword, signInWithEmailAndPassword, setPersistence, browserLocalPersistence, onAuthStateChanged } from "firebase/auth";
import { auth } from "@/firebase/firebaseInit";

// import { Database } from "../database/databaseService";

import store from "../../store";

export const Auth = {
    async signUp(email, password) {
        let response = {
            user: null,
            message: null,
            status: null,
        };
        await setPersistence(auth, browserLocalPersistence)
        .then(async () => {
            await createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
                response.user = userCredential.user;
                response.message = 'Sign Up Successful';
                response.status = "success";
            })
        })
        .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        response.status = "error";
        response.message = errorMessage;
        response.errorCode = errorCode;
        });
        return response
    },

    async signIn(email, password) {
        let response = {
            user: null,
            message: null,
            status: null,
        }
        await setPersistence(auth, browserLocalPersistence)
            .then(async () => {
                await signInWithEmailAndPassword(auth, email, password)
                    .then((userCredential) => {
                        response.user = userCredential.user;
                        response.message = 'Sign In Successful';
                        response.status = "success"
                })
        })
        .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        response.status = "error";
        response.message = errorMessage;
        response.errorCode = errorCode;
        });
        return response
    },

    authStatePromise() {
        return new Promise((resolve) => {
            // Use the onAuthStateChanged listener to manage the authenticated user
            onAuthStateChanged(auth, (user) => {
                if (user) {
                    store.commit('auth/storeUser', user);
                    resolve(user);
                    return user
                }
                resolve(user);
            })
        })
    }
}

